import { Link } from "gatsby"
import React, { useEffect, useState } from "react"
import Button from "../components/Button"
import Layout from "../components/Layout"
import Title from "../components/Title"
import { Icon10 } from "../components/Icons"

const Ok = () => {
  return (
    <div className="w-full flex items-center justify-center h-full">
      <Icon10 />
    </div>
  )
}

const ResPlan = ({}) => {
  const [plan, setPlan] = useState(0)
  useEffect(() => {
    switch (plan) {
      case 0:
        break

      default:
        break
    }
  }, [plan])
  return (
    <div className="flex flex-col w-full gap-12 md:hidden">
      <div className="flex w-full flex-wrap sm:text-lg text-base">
        <button
          onClick={() => setPlan(0)}
          className={`w-max max-w-full  p-4 ${
            plan === 0 ? "text-white bg-blue" : "text-black font-bold "
          }`}
        >
          Starter
        </button>
        <button
          onClick={() => setPlan(1)}
          className={`w-max max-w-full  p-4 ${
            plan === 1 ? "text-white bg-blue" : "text-black font-bold "
          }`}
        >
          Intermediate
        </button>
        <button
          onClick={() => setPlan(2)}
          className={`w-max max-w-full  p-4 ${
            plan === 2 ? "text-white bg-blue" : "text-black font-bold "
          }`}
        >
          Ultimate
        </button>
      </div>
      <table className="w-full h-full mt-12">
        <thead></thead>
        <tbody>
          <tr>
            <td className=" hd">Wireframes</td>
            <td className="">
              {data[plan].wf === "ok" ? <Ok /> : data[plan].wf}
            </td>
          </tr>
          <tr className="bg-blue bg-opacity-10">
            <td className=" hd">Mockups</td>
            <td className="">
              {data[plan].mo === "ok" ? <Ok /> : data[plan].mo}
            </td>
          </tr>
          <tr>
            <td className=" hd">Branding</td>
            <td className="">
              {data[plan].br === "ok" ? <Ok /> : data[plan].br}
            </td>
          </tr>
          <tr className="bg-blue bg-opacity-10">
            <td className=" hd">Number of Pages</td>
            <td className="">
              {data[plan].nop === "ok" ? <Ok /> : data[plan].nop}
            </td>
          </tr>
          <tr>
            <td className=" hd">Per Additional Page</td>
            <td className="">
              {data[plan].pap === "ok" ? <Ok /> : data[plan].pap}
            </td>
          </tr>
          <tr className="bg-blue bg-opacity-10">
            <td className=" hd">SEO</td>
            <td className="">
              {data[plan].seo === "ok" ? <Ok /> : data[plan].seo}
            </td>
          </tr>
          <tr>
            <td className=" hd">Content Management System</td>
            <td className="">
              {data[plan].cms === "ok" ? <Ok /> : data[plan].cms}
            </td>
          </tr>
          <tr className="bg-blue bg-opacity-10">
            <td className=" hd">Email Integration</td>
            <td className="">
              {data[plan].ei === "ok" ? <Ok /> : data[plan].ei}
            </td>
          </tr>
          <tr>
            <td className=" hd">Hosting</td>
            <td className="">
              {data[plan].hosting === "ok" ? <Ok /> : data[plan].hosting}
            </td>
          </tr>
          <tr className="bg-blue bg-opacity-10">
            <td className=" hd">Custom Domain</td>
            <td className="">
              {data[plan].cd === "ok" ? <Ok /> : data[plan].cd}
            </td>
          </tr>
          <tr>
            <td className=" hd">Storage</td>
            <td className="">
              {data[plan].storage === "ok" ? <Ok /> : data[plan].storage}
            </td>
          </tr>
          <tr className="bg-blue bg-opacity-10">
            <td className=" hd">Website Security</td>
            <td className="">
              {data[plan].ws === "ok" ? <Ok /> : data[plan].ws}
            </td>
          </tr>
          <tr>
            <td className=" hd">Weekly Backup For Website</td>
            <td className="">
              {data[plan].wb === "ok" ? <Ok /> : data[plan].wb}
            </td>
          </tr>
          <tr className="bg-blue bg-opacity-10">
            <td className=" hd">Support & Maintainance</td>
            <td className="">
              {data[plan].sm === "ok" ? <Ok /> : data[plan].sm}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
const data = [
  {
    wf: "ok",
    mo: "ok",
    br: "ok",
    nop: "2",
    pap: "$5",
    seo: "ok",
    ei: "",
    cms: "",
    hosting: "ok",
    cd: "ok",
    storage: "ok",
    ws: "ok",
    wb: "",
    sm: "24% Anually (1st year free)",
  },
  {
    wf: "ok",
    mo: "ok",
    br: "ok",
    nop: "6",
    pap: "$8",
    seo: "ok",
    ei: "ok",
    cms: "ok",
    hosting: "ok",
    cd: "ok",
    storage: "ok",
    ws: "ok",
    wb: "ok",
    sm: "25% Anually (1st year free)",
  },
  {
    wf: "ok",
    mo: "ok",
    br: "ok",
    nop: "12",
    pap: "$8",
    seo: "ok",
    ei: "ok",
    cms: "ok",
    hosting: "ok",
    cd: "ok",
    storage: "ok",
    ws: "ok",
    wb: "ok",
    sm: "25% Anually (1st year free)",
  },
]
const Table = () => {
  return (
    <div className="w-full md:flex h-full flex-col gap-32 mt-12 hidden">
      <table className="w-full h-full ">
        <thead>
          <tr>
            <th className=""></th>
            <th className="bg-blue">Starter</th>
            <th className="bg-blue">Intermediate</th>
            <th className="bg-blue">Ultimate</th>
          </tr>
        </thead>

        <tbody>
          <tr className="border-none">
            <td className=" text-left py-6"></td>
          </tr>
          <tr>
            <td className=" hd">Wireframes</td>
            <td className="">
              <Ok />
            </td>
            <td className="">
              <Ok />
            </td>
            <td className="">
              <Ok />
            </td>
          </tr>
          <tr className="bg-blue bg-opacity-10">
            <td className=" hd ">Mockups</td>
            <td className="">
              <Ok />
            </td>
            <td className="">
              <Ok />
            </td>
            <td className="">
              <Ok />
            </td>
          </tr>
          <tr>
            <td className=" hd">Branding</td>
            <td className="">
              <Ok />
            </td>
            <td className="">
              <Ok />
            </td>
            <td className="">
              <Ok />
            </td>
          </tr>
          <tr className="bg-blue bg-opacity-10">
            <td className=" hd">Number of Pages</td>
            <td className="">2 </td>
            <td className="">6 </td>
            <td className="">8</td>
          </tr>
          <tr>
            <td className=" hd">Per Additional Page</td>
            <td className="">$5</td>
            <td className="">$8</td>
            <td className="">$8</td>
          </tr>
          <tr className="bg-blue bg-opacity-10">
            <td className="hd">SEO</td>
            <td className="">
              <Ok />
            </td>
            <td className="">
              <Ok />
            </td>
            <td className="">
              <Ok />
            </td>
          </tr>

          <tr>
            <td className=" hd">Content Management System</td>
            <td className=""></td>
            <td className="">
              <Ok />
            </td>
            <td className="">
              <Ok />
            </td>
          </tr>
          <tr className="bg-blue bg-opacity-10">
            <td className=" hd">Email Integration</td>
            <td className=""></td>
            <td className="">
              <Ok />
            </td>
            <td className="">
              <Ok />
            </td>
          </tr>
          <tr>
            <td className=" hd">Hosting</td>
            <td className="">
              <Ok />
            </td>
            <td className="">
              <Ok />
            </td>
            <td className="">
              <Ok />
            </td>
          </tr>
          <tr className="bg-blue bg-opacity-10">
            <td className=" hd">Custom Domain</td>
            <td className="">
              <Ok />
            </td>
            <td className="">
              <Ok />
            </td>
            <td className="">
              <Ok />
            </td>
          </tr>
          <tr>
            <td className=" hd">Storage</td>
            <td className=""></td>
            <td className="">
              <Ok />
            </td>
            <td className="">
              <Ok />
            </td>
          </tr>
          <tr className="bg-blue bg-opacity-10">
            <td className=" hd">Website Security</td>
            <td className="">
              <Ok />
            </td>
            <td className="">
              <Ok />
            </td>
            <td className="">
              <Ok />
            </td>
          </tr>
          <tr>
            <td className=" hd">Weekly Backup For Website</td>
            <td className=""></td>
            <td className="">
              <Ok />
            </td>
            <td className="">
              <Ok />
            </td>
          </tr>
          <tr className="bg-blue bg-opacity-10">
            <td className=" hd">Support & Maintainance</td>
            <td className="">24% Anually (1st year free)</td>
            <td className="">25% Anually (1st year free)</td>
            <td className="">25% Anually (1st year free)</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
const Plan = ({ title, text, price,priceLkr,link }) => {
  return (
    <div className="flex flex-col gap-8 w-full max-w-sm items-center text-center">
      <div className="text-xl font-bold">{title}</div>
      <div className="text-base sm:text-lg">{text}</div>
      <div className="font-bold flex flex-col gap-2">
          <div className="w-full text-2xl ">{price}</div>
          <div className="w-full text-lg ">{priceLkr}</div>
      </div>
      <Link to={`/get-started?plan=${link}`} className="w-max max-w-full">
        <Button>Inquire Now</Button>
      </Link>
    </div>
  )
}
const Plans = () => {
  return (
    <div className="flex flex-col items-center mt-12">
        <Title>Plans We Provide</Title>
      <div className="flex flex-wrap gap-24 justify-center">
      <Plan
        title="Starter"
        text="Perfect for beginners at the campaign of building and promoting their brands or who wants to showcase their abilities online.  "
        price="$30"
        priceLkr="6000 LKR"
        link="starter"
      />
      <Plan
        title="Intermediate"
        text="Perfect for  groups who currently running a industry level functions with a need of quality  online solution. "
        price="$42"
        priceLkr="8400 LKR"
        link="intermediate"
      />
      <Plan
        title="Ultimate"
        text="Perfect for corparations and companies whose having a well known brand name with a need of luxury online solution. Suitable for data driven web apps, content promoting sites and e-commerce solutions. "
        price="$64"
        priceLkr="12800 LKR"
        link="ultimate"
      />
      </div>
    </div>
  )
}
const Custom = ()=>{
    return(
      <div className="flex flex-col   w-full items-center">
        <Title>Need A Custom Plan</Title>
        <div className="text-base sm:text-lg mb-8 text-center max-w-md">
          If you are not interested in these plans and prices we are ready to give you what you want for the fairest price.
        </div>
        <Link to="/contact"><Button>Contact Us</Button></Link>
      </div>
    )
  }
export default function Pricing({ location }) {
  return (
    <Layout location={location.pathname}>
      <div className="flex flex-col w-full gap-48 h-full max-w-5xl w-full mx-auto text-base  sm:text-lg  px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 ">
        
        <Plans />
        <Table />
        <ResPlan />
        <Custom/>
      </div>
    </Layout>
  )
}
